import React, {useState, useEffect} from 'react';
import 'fontsource-roboto';
import {makeStyles, useTheme} from '@material-ui/styles';
import useIsMountedRef from './../Components/useIsMountedRef';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import Box from '@material-ui/core/Box';
import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Autocomplete from '@material-ui/lab/Autocomplete';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';

import ReactExport from 'react-data-export';

import SearchIcon from '@material-ui/icons/Search';
import SaveIcon from '@material-ui/icons/Save';
import DeleteIcon from '@material-ui/icons/Delete';

import Warning from '../Components/Warning';

const useStyles = makeStyles(theme => ({
  errorMain: {
    color: theme.palette.error.contrastText,
    backgroundColor: theme.palette.error.main
  },
  errorLight: {
    color: theme.palette.error.contrastText,
    backgroundColor: theme.palette.error.light
  },
  errorDark: {
    color: theme.palette.error.contrastText,
    backgroundColor: theme.palette.error.dark
  },
  warningMain: {
    color: theme.palette.warning.contrastText,
    backgroundColor: theme.palette.warning.main
  },
  warningLight: {
    color: theme.palette.warning.contrastText,
    backgroundColor: theme.palette.warning.light
  },
  warningDark: {
    color: theme.palette.warning.contrastText,
    backgroundColor: theme.palette.warning.dark
  },
  infoMain: {
    color: theme.palette.info.contrastText,
    backgroundColor: theme.palette.info.main
  },
  infoLight: {
    color: theme.palette.info.contrastText,
    backgroundColor: theme.palette.info.light
  },
  infoDark: {
    color: theme.palette.info.contrastText,
    backgroundColor: theme.palette.info.dark
  },
  successMain: {
    color: theme.palette.success.contrastText,
    backgroundColor: theme.palette.success.main
  },
  successLight: {
    color: theme.palette.success.contrastText,
    backgroundColor: theme.palette.success.light
  },
  successDark: {
    color: theme.palette.success.contrastText,
    backgroundColor: theme.palette.success.dark
  },
  divider: {
    margin: theme.spacing(.5, 0)
  },
  link: {
    textDecoration: 'initial',
    color: 'inherit',
    '&:active': {
      color: 'inherit'
    }
  },
  card: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    margin: theme.spacing(0.5)
  },
  cardHeader: {
    padding: theme.spacing(1, 2, 1)
  },
  cardContent: {
    flexGrow: 1,
    padding: theme.spacing(1),
    '&:last-child': {
      paddingBottom: theme.spacing(1)
    }
  },
  fab: {
    position: 'fixed',
    bottom: theme.spacing(2),
    right: theme.spacing(2),
  }
}));

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

export default function ResellerServices(props) {
  const theme = useTheme();
  const classes = useStyles();
  const ajax = props.ajax;

  const isMountedRef = useIsMountedRef();

  const [isLoaded, setIsLoaded] = useState(false);
  const [filter, setFilter] = useState({
    text: ''
  });
  const [data, setData] = useState([]);

  useEffect(() => {
    setIsLoaded(false);
    ajax('resellerServices')
      .then(response => {
        if (!isMountedRef.current) return;

        if (response.ok)
          setData(response.data);

        setIsLoaded(true);
      });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleFilterChange = e => {
    setFilter({
      ...filter,
      [e.target.name]: e.target.type === 'checkbox' ? e.target.checked : e.target.value !== null ? e.target.value : ''
    });
  };

  const filterData = item => true
      && item.price !== '-'
      && (
           (item.service && !!~item.service.toLowerCase().indexOf(filter.text.toLowerCase()))
        || (item.servicePack && !!~item.servicePack.toLowerCase().indexOf(filter.text.toLowerCase()))
      );

  const handleServicePackAdd = (e, value, reason) => {
    switch (reason) {
      case 'select-option':
        setData({...data, servicePacks: data.servicePacks.map(servicePack => servicePack.idServicePackSL === value.idServicePackSL ? {...servicePack, isEditable: '1'} : servicePack)});
        break;
      default:
        break;
    };
  };
  const handleServiceAdd = (e, value, reason) => {
    switch (reason) {
      case 'select-option':
        setData({...data, services: data.services.map(service => service.idServiceSL === value.idServiceSL ? {...service, isEditable: '1'} : service)});
        break;
      default:
        break;
    };
  };

  const handleDataChange = (idServicePackSL, idServiceSL, price) => {
    setData({
      ...data,
      servicePacks: data.servicePacks.map(servicePack => servicePack.idServicePackSL === idServicePackSL ? {...servicePack, price: price, profit: (price - servicePack.priceSL).toFixed(2)} : servicePack),
      services: data.services.map(service => service.idServiceSL === idServiceSL ? {...service, price: price, profit: (price - service.priceSL).toFixed(2)} : service)
    });
  };

  const saveServicePackPrice = (idServicePackSL, price) => {
    setData({...data, servicePacks: data.servicePacks.map(servicePack => servicePack.idServicePackSL === idServicePackSL ? {...servicePack, isEditable: '0'} : servicePack)});
    ajax('resellerServicePackPriceSave', {
      idServicePackSL: idServicePackSL,
      price: price
    })
      .then(response => {
        if (!isMountedRef.current) return;

        if (response.ok)
          setData(response.data);
      });
  };
  const saveServicePrice = (idServiceSL, price) => {
    setData({...data, services: data.services.map(service => service.idServiceSL === idServiceSL ? {...service, isEditable: '0'} : service)});
    ajax('resellerServicePriceSave', {
      idServiceSL: idServiceSL,
      price: price
    })
      .then(response => {
        if (!isMountedRef.current) return;

        if (response.ok)
          setData(response.data);
      });
  };

  const deleteServicePackPrice = (idResellerServicePrice) => {
    setData({...data, servicePacks: data.servicePacks.map(servicePack => servicePack.id === idResellerServicePrice ? {...servicePack, isEditable: '0'} : servicePack)});
    ajax('resellerServicePriceDelete', {
      idResellerServicePrice: idResellerServicePrice
    })
      .then(response => {
        if (!isMountedRef.current) return;

        if (response.ok)
          setData(response.data);
      });
  };
  const deleteServicePrice = (idResellerServicePrice) => {
    setData({...data, services: data.services.map(service => service.id === idResellerServicePrice ? {...service, isEditable: '0'} : service)});
    ajax('resellerServicePriceDelete', {
      idResellerServicePrice: idResellerServicePrice
    })
      .then(response => {
        if (!isMountedRef.current) return;

        if (response.ok)
          setData(response.data);
      });
  };

  return (
    <Container maxWidth='md'>
      <Typography variant='h6'>Administrare servicii</Typography>
      <Typography variant='subtitle2'>Administrare servicii proprii prin laboratorul de analize Sunmed Tulcea</Typography>
      <Divider className={classes.divider} />

      {!isLoaded &&
        <Box display='block' align='center'>
          <CircularProgress />
        </Box>
      }

      {isLoaded && data.length === 0 &&
        <Warning variant='subtitle2' align='center'>Nu exista nici o inregistrare care sa corespunda conditiilor cerute.</Warning>
      }

      {isLoaded && data.length > 0 &&
        <Grid container>
          <Grid item xs={12}>
            <TextField margin='none' autoComplete='off'
              InputProps={{
                startAdornment: (
                  <InputAdornment position='start'>
                    <SearchIcon />
                  </InputAdornment>
                )
              }}
              label='Filtrare rapida'
              placeholder='Filtrare rapida'
              name='text'
              value={filter.text}
              onChange={handleFilterChange}
            />
          </Grid>
        </Grid>
      }

      {isLoaded && data.length > 0 && data.filter(filterData).length === 0 &&
        <Warning variant='subtitle2' align='center'>Nu exista nici o inregistrare care sa corespunda filtrelor aplicate.</Warning>
      }

      {isLoaded &&
        <Grid container alignItems='stretch'>
          <Grid item xs={12}><Typography variant='subtitle1'>Lista pachetelor de servicii</Typography></Grid>
          <Grid item xs={12}>
            <Autocomplete clearOnBlur={true} blurOnSelect className={classes.infoLight}
              key={JSON.stringify(data.servicePacks).split('').reduce((a,b)=>{a=((a<<5)-a)+b.charCodeAt(0);return a&a},0)}
              options={data.servicePacks.filter(servicePack => !Boolean(parseInt(servicePack.isEditable)) && servicePack.price === servicePack.priceSL)}
              getOptionLabel={servicePack => servicePack.servicePack}
              renderInput={params => <TextField {...params} label='Configurati un alt pachet de servicii' />}
              onChange={handleServicePackAdd}
            />
          </Grid>
          {data.servicePacks.filter(servicePack => Boolean(parseInt(servicePack.isEditable))).filter(filterData).map(item =>
            <Grid key={item.idServicePackSL} item xs={12} sm={6} md={4} style={{display: 'flex'}}>
              <Card className={classes.card}>
                <CardHeader className={classes.cardHeader} style={{flexGrow: 1}}
                  avatar={
                    <IconButton color='primary'
                      onClick={() => saveServicePackPrice(item.idServicePackSL, item.price)}
                    >
                      <SaveIcon />
                    </IconButton>
                  }
                  title={<Typography variant='subtitle2'>{item.servicePack}</Typography>}
                />
                <CardContent className={classes.cardContent} style={{flexGrow: 0}}>
                  <Box style={{display: 'flex'}}>
                    <Typography color='textSecondary'>Pret achizitie:</Typography>
                    <Typography color='secondary' align='right' style={{flexGrow: 1}}>{item.priceSL} RON</Typography>
                  </Box>
                  <Box style={{display: 'flex'}}>
                    <Typography color='textSecondary' style={{flexGrow: 1, whiteSpace: 'nowrap'}}>Pret vanzare:</Typography>
                    <Typography color='primary' align='right' component='div'>
                      <TextField color='primary' margin='none' autoComplete='off' autoFocus
                        inputProps={{
                          style: {
                            maxWidth: '60px',
                            padding: '1px 4px',
                            textAlign: 'right',
                            fontSize: '0.875rem',
                            color: '#3f51b5'
                          }
                        }}
                        placeholder='Pret vanzare'
                        name='price'
                        value={item.price}
                        onChange={e => handleDataChange(item.idServicePackSL, null, e.target.value)}
                        onFocus={e => e.target.select()}
                        onKeyPress={e => e.key === 'Enter' ? saveServicePackPrice(item.idServicePackSL, item.price) : null}
                      />
                    </Typography>
                    <Typography color='primary' align='right'> RON</Typography>
                  </Box>
                  <Box style={{
                    display: 'flex',
                    color: parseInt(item.price) === 0 ? 'initial' : +item.profit < 0 ? theme.palette.error.contrastText : 'initial',
                    backgroundColor: parseInt(item.price) === 0 ? 'initial' : +item.profit < 0 ? theme.palette.error.main : 'initial'
                  }}>
                    <Typography color='textSecondary'>Profit:</Typography>
                    <Typography color='primary' align='right' style={{
                      flexGrow: 1,
                      color: parseInt(item.price) === 0 ? 'initial' : +item.profit < 0 ? theme.palette.error.contrastText : theme.palette.success.light,
                      backgroundColor: parseInt(item.price) === 0 ? 'initial' : +item.profit < 0 ? theme.palette.error.main : 'initial',
                      fontWeight: 'bold'
                    }}>
                      {parseInt(item.price) === 0 ? 'N/A' : `${item.profit} RON`}
                    </Typography>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          )}

          {data.servicePacks.filter(servicePack => !Boolean(parseInt(servicePack.isEditable)) && servicePack.price !== servicePack.priceSL).filter(filterData).map(item =>
            <Grid key={item.idServicePackSL} item xs={12} sm={6} md={4} style={{display: 'flex'}}>
              <Card className={classes.card}>
                <CardHeader className={classes.cardHeader} style={{flexGrow: 1}}
                  avatar={
                    <IconButton color='secondary'
                      onClick={() => deleteServicePackPrice(item.id)}
                    >
                      <DeleteIcon />
                    </IconButton>
                  }
                  title={<Typography color='textSecondary'>{item.servicePack}</Typography>}
                />
                <CardContent className={classes.cardContent} style={{flexGrow: 0}}>
                  <Box style={{display: 'flex'}}>
                    <Typography color='textSecondary'>Pret achizitie:</Typography>
                    <Typography color='secondary' align='right' style={{flexGrow: 1}}>{item.priceSL} RON</Typography>
                  </Box>
                  <Box style={{display: 'flex'}}>
                    <Typography color='textSecondary'>Pret vanzare:</Typography>
                    <Typography color='primary' align='right' style={{flexGrow: 1}}>{item.price} RON</Typography>
                  </Box>
                  <Box style={{
                    display: 'flex',
                    color: parseInt(item.price) === 0 ? 'initial' : +item.profit < 0 ? theme.palette.error.contrastText : 'initial',
                    backgroundColor: parseInt(item.price) === 0 ? 'initial' : +item.profit < 0 ? theme.palette.error.main : 'initial'
                  }}>
                    <Typography color='textSecondary'>Profit:</Typography>
                    <Typography color='primary' align='right' style={{
                      flexGrow: 1,
                      color: parseInt(item.price) === 0 ? 'initial' : +item.profit < 0 ? theme.palette.error.contrastText : theme.palette.success.light,
                      backgroundColor: parseInt(item.price) === 0 ? 'initial' : +item.profit < 0 ? theme.palette.error.main : 'initial',
                      fontWeight: 'bold'
                    }}>
                      {parseInt(item.price) === 0 ? 'N/A' : `${item.profit} RON`}
                    </Typography>
                  </Box>
                </CardContent>
                <CardActions disableSpacing></CardActions>
              </Card>
            </Grid>
          )}
        </Grid>
      }

      {isLoaded &&
        <Grid container alignItems='stretch'>
          <Grid item xs={12}><Typography variant='subtitle1'>Lista servicii</Typography></Grid>
          <Grid item xs={9}>
            <Autocomplete clearOnBlur={true} blurOnSelect className={classes.infoLight}
              key={JSON.stringify(data.services).split('').reduce((a,b)=>{a=((a<<5)-a)+b.charCodeAt(0);return a&a},0)}
              options={data.services.filter(service => !Boolean(parseInt(service.isEditable)) && service.price === service.priceSL)}
              getOptionLabel={service => service.service}
              groupBy={service => service.category}
              renderInput={params => <TextField {...params} label='Configurati un alt serviciu' />}
              onChange={handleServiceAdd}
            />
          </Grid>
          <Grid item xs={3} style={{padding: '2px 12px'}}>
            <ExcelFile
              filename={`Lista servicii`}
              element={
                <Button variant='contained' size='large' color='primary' fullWidth>
                  Lista servicii
                </Button>
              }
            >
              <ExcelSheet
                data={data.services}
                name='Sheet 1'
              >
                <ExcelColumn label='Categorie' value='category' />
                <ExcelColumn label='Serviciu' value='service' />
                <ExcelColumn label='Pret achizitie' value='priceSL' />
                <ExcelColumn label='Pret vanzare' value='price' />
                <ExcelColumn label='Profit' value='profit' />
              </ExcelSheet>
            </ExcelFile>
          </Grid>
          {data.services.filter(service => Boolean(parseInt(service.isEditable))).filter(filterData).map(item =>
            <Grid key={item.idServiceSL} item xs={12} sm={6} md={4} style={{display: 'flex'}}>
              <Card className={classes.card}>
                <CardHeader className={classes.cardHeader} style={{flexGrow: 1}}
                  avatar={
                    <IconButton color='primary'
                      onClick={() => saveServicePrice(item.idServiceSL, item.price)}
                    >
                      <SaveIcon />
                    </IconButton>
                  }
                  title={<Typography color='textSecondary'>{item.category}</Typography>}
                  subheader={<Typography variant='subtitle2'>{item.service}</Typography>}
                />
                <CardContent className={classes.cardContent} style={{flexGrow: 0}}>
                  <Box style={{display: 'flex'}}>
                    <Typography color='textSecondary'>Pret achizitie:</Typography>
                    <Typography color='secondary' align='right' style={{flexGrow: 1}}>{item.priceSL} RON</Typography>
                  </Box>
                  <Box style={{display: 'flex'}}>
                    <Typography color='textSecondary' style={{flexGrow: 1, whiteSpace: 'nowrap'}}>Pret vanzare:</Typography>
                    <Typography color='primary' align='right' component='div'>
                      <TextField color='primary' margin='none' autoComplete='off' autoFocus
                        inputProps={{
                          style: {
                            maxWidth: '60px',
                            padding: '1px 4px',
                            textAlign: 'right',
                            fontSize: '0.875rem',
                            color: '#3f51b5'
                          }
                        }}
                        placeholder='Pret vanzare'
                        name='price'
                        value={item.price}
                        onChange={e => handleDataChange(null, item.idServiceSL, e.target.value)}
                        onFocus={e => e.target.select()}
                        onKeyPress={e => e.key === 'Enter' ? saveServicePrice(item.idServiceSL, item.price) : null}
                      />
                    </Typography>
                    <Typography color='primary' align='right'> RON</Typography>
                  </Box>
                  <Box style={{
                    display: 'flex',
                    color: +item.profit < 0 ? theme.palette.error.contrastText : 'initial',
                    backgroundColor: +item.profit < 0 ? theme.palette.error.main : 'initial'
                  }}>
                    <Typography color='textSecondary'>Profit:</Typography>
                    <Typography color='primary' align='right' style={{
                      flexGrow: 1,
                      color: +item.profit < 0 ? theme.palette.error.contrastText : theme.palette.success.light,
                      backgroundColor: +item.profit < 0 ? theme.palette.error.main : 'initial',
                      fontWeight: 'bold'
                    }}>
                      {item.profit} RON
                    </Typography>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          )}

          {data.services.filter(service => !Boolean(parseInt(service.isEditable)) && service.price !== service.priceSL).filter(filterData).map(item =>
            <Grid key={item.idServiceSL} item xs={12} sm={6} md={4} style={{display: 'flex'}}>
              <Card className={classes.card}>
                <CardHeader className={classes.cardHeader} style={{flexGrow: 1}}
                  avatar={
                    <IconButton color='secondary'
                      onClick={() => deleteServicePrice(item.id)}
                    >
                      <DeleteIcon />
                    </IconButton>
                  }
                  title={<Typography color='textSecondary'>{item.category}</Typography>}
                  subheader={<Typography variant='subtitle2'>{item.service}</Typography>}
                />
                <CardContent className={classes.cardContent} style={{flexGrow: 0}}>
                  <Box style={{display: 'flex'}}>
                    <Typography color='textSecondary'>Pret achizitie:</Typography>
                    <Typography color='secondary' align='right' style={{flexGrow: 1}}>{item.priceSL} RON</Typography>
                  </Box>
                  <Box style={{display: 'flex'}}>
                    <Typography color='textSecondary'>Pret vanzare:</Typography>
                    <Typography color='primary' align='right' style={{flexGrow: 1}}>{item.price} RON</Typography>
                  </Box>
                  <Box style={{
                    display: 'flex',
                    color: +item.profit < 0 ? theme.palette.error.contrastText : 'initial',
                    backgroundColor: +item.profit < 0 ? theme.palette.error.main : 'initial'
                  }}>
                    <Typography color='textSecondary'>Profit:</Typography>
                    <Typography color='primary' align='right' style={{
                      flexGrow: 1,
                      color: +item.profit < 0 ? theme.palette.error.contrastText : theme.palette.success.light,
                      backgroundColor: +item.profit < 0 ? theme.palette.error.main : 'initial',
                      fontWeight: 'bold'
                    }}>
                      {item.profit} RON
                    </Typography>
                  </Box>
                </CardContent>
                <CardActions disableSpacing></CardActions>
              </Card>
            </Grid>
          )}
        </Grid>
      }
    </Container>
  );
}